// extracted by mini-css-extract-plugin
export default {"cTableLoader":"TableLoader_cTableLoader__FxU4Z"};